
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as ArrowIcon } from 'Assets/svg/right-arrow.svg';
import trialUserPaginationImg from 'Assets/png/trialUserPaginationImg.png';
import Button from './Button';
import HocPopupComponent from './hocPopupComponent';

class TrialUserPaginationPopupState {
  @observable showPaginationTrialUserPopup = false;

  @action
  setShowPaginationTrialUserPopup(val = false) {
    this.showPaginationTrialUserPopup = val;
  }
}
const trialUserPaginationPopupState = new TrialUserPaginationPopupState();

const PaginationTrialUserPopup = props => {
  const { closeClick = () => {} } = props;
  const upgradeNowBtnClick = () => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_AS_EVENTS.LB_AS_PAGINATION_UPGRADE_NOW,
      {},
    );
    closeClick();
    Utils.showUserPricingPopup(true, 'pagination', false);
  };
  return (
    <div className="technology-demo-popup-wrapper">
      <div className="img-wrap">
        <img src={trialUserPaginationImg} alt="trialUserPaginationImg" />
      </div>
      <div className="msg-text-wrap">
        Only first 50 results are available during the trial. Please purchase a
        plan to access more.
      </div>
      <Button
        btnText="Upgrade Now"
        icon={false}
        iconName=""
        type="button"
        className="action-btn"
        svg={<ArrowIcon className="arrow-right" width={14} height={18} />}
        click={e => upgradeNowBtnClick(e)}
      />
    </div>
  );
};

const TrialUserPaginationPopup = observer(props => {
  const closePopup = () => {
    trialUserPaginationPopupState.setShowPaginationTrialUserPopup(false);
  };

  return trialUserPaginationPopupState.showPaginationTrialUserPopup ? (
    <HocPopupComponent
      customClassName="trial-user-pagination-upgrade-popup"
      closeClick={closePopup}
      showCloseIcon
    >
      <PaginationTrialUserPopup closeClick={closePopup} />
    </HocPopupComponent>
  ) : (
    ''
  );
});

export { TrialUserPaginationPopup, trialUserPaginationPopupState };
export default TrialUserPaginationPopup;
